;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { salaryPeriodOptions } from './carerix/dataNodes/salary';

const formatSalaryString = (job: Job) => {
  const { salary, language } = job;
  if (!salary || !salary.publishSalary || (!salary.min && !salary.max)) return null;

  // If this number has any digits after the decimal point, only return them if
  // they're not 0 or 00.
  const formatDecimals = (value: string) => {
    if (value?.includes('.')) {
      const decimalPart = value.split('.')[1];
      if (decimalPart === '0' || decimalPart === '00') return Math.floor(+value);
    }
    return value;
  };

  const { min, max, period } = salary;
  const minAmount = formatDecimals(min);
  const maxAmount = formatDecimals(max);
  let amount;
  if (minAmount !== null && maxAmount !== null && minAmount !== maxAmount) amount = `${minAmount} - ${maxAmount}`;
  else amount = minAmount !== null ? minAmount : maxAmount;

  const periodMap = salaryPeriodOptions.find((option) => option.value === period);
  const periodLabel = periodMap?.labels.find((label) => label.language === language)?.label || period;

  return `€ ${amount} ${periodLabel}`;
};

export default formatSalaryString;
